import api from "api/flexapi";
import humps from "humps";

export const GET_CLAIM_CATEGORIES_START = "GET_CLAIM_CATEGORIES_START";
export const GET_CLAIM_CATEGORIES_SUCCESS = "GET_CLAIM_CATEGORIES_SUCCESS";
export const GET_CLAIM_CATEGORIES_ERROR = "GET_CLAIM_CATEGORIES_ERROR";

export const GET_INSURER_CLAIM_CATEGORIES_START = "GET_INSURER_CLAIM_CATEGORIES_START";
export const GET_INSURER_CLAIM_CATEGORIES_SUCCESS = "GET_INSURER_CLAIM_CATEGORIES_SUCCESS";
export const GET_INSURER_CLAIM_CATEGORIES_ERROR = "GET_INSURER_CLAIM_CATEGORIES_ERROR";

export const GET_CLAIM_ACCOUNTS_START = "GET_CLAIM_ACCOUNTS_START";
export const GET_CLAIM_ACCOUNTS_SUCCESS = "GET_CLAIM_ACCOUNTS_SUCCESS";
export const GET_CLAIM_ACCOUNTS_ERROR = "GET_CLAIM_ACCOUNTS_ERROR";

export const GET_CLAIM_ITEM_START = "GET_CLAIM_ITEM_START";
export const GET_CLAIM_ITEM_SUCCESS = "GET_CLAIM_ITEM_SUCCESS";
export const GET_CLAIM_ITEM_ERROR = "GET_CLAIM_ITEM_ERROR";

export const CHECK_CLAIM_REACH_LIMIT_START = "CHECK_CLAIM_REACH_LIMIT_START";
export const CHECK_CLAIM_REACH_LIMIT_SUCCESS = "CHECK_CLAIM_REACH_LIMIT_SUCCESS";
export const CHECK_CLAIM_REACH_LIMIT_ERROR = "CHECK_CLAIM_REACH_LIMIT_ERROR";

export const CONVERT_HEIC_START = "CONVERT_HEIC_START";
export const CONVERT_HEIC_SUCCESS = "CONVERT_HEIC_SUCCESS";
export const CONVERT_HEIC_ERROR = "CONVERT_HEIC_ERROR";

export const UPLOAD_CLAIM_RECEIPT_START = "UPLOAD_CLAIM_RECEIPT_START";
export const UPLOAD_CLAIM_RECEIPT_SUCCESS = "UPLOAD_CLAIM_RECEIPT_SUCCESS";
export const UPLOAD_CLAIM_RECEIPT_ERROR = "UPLOAD_CLAIM_RECEIPT_ERROR";

export const DELETE_CLAIM_RECEIPT_START = "DELETE_CLAIM_RECEIPT_START";
export const DELETE_CLAIM_RECEIPT_SUCCESS = "DELETE_CLAIM_RECEIPT_SUCCESS";
export const DELETE_CLAIM_RECEIPT_ERROR = "DELETE_CLAIM_RECEIPT_ERROR";

export const DELETE_CLAIM_REFERRAL_START = "DELETE_CLAIM_REFERRAL_START";
export const DELETE_CLAIM_REFERRAL_SUCCESS = "DELETE_CLAIM_REFERRAL_SUCCESS";
export const DELETE_CLAIM_REFERRAL_ERROR = "DELETE_CLAIM_REFERRAL_ERROR";

export const DELETE_CLAIM_DOCUMENT_START = "DELETE_CLAIM_DOCUMENT_START";
export const DELETE_CLAIM_DOCUMENT_SUCCESS = "DELETE_CLAIM_DOCUMENT_SUCCESS";
export const DELETE_CLAIM_DOCUMENT_ERROR = "DELETE_CLAIM_DOCUMENT_ERROR";

export const GET_RECEIPT_OCR_START = "GET_RECEIPT_OCR_START";
export const GET_RECEIPT_OCR_SUCCESS = "GET_RECEIPT_OCR_SUCCESS";
export const GET_RECEIPT_OCR_ERROR = "GET_RECEIPT_OCR_ERROR";

export const SAVE_CLAIM_DRAFT_BEGIN = "SAVE_CLAIM_DRAFT_BEGIN";
export const SAVE_CLAIM_DRAFT_SUCCESS = "SAVE_CLAIM_DRAFT_SUCCESS";
export const SAVE_CLAIM_DRAFT_ERROR = "SAVE_CLAIM_DRAFT_ERROR";

export const SET_SELECTED_CLAIMANT = "SET_SELECTED_CLAIMANT";
export const SET_SELECTED_PLAN_YEAR = "SET_SELECTED_PLAN_YEAR";
export const SET_SELECTED_CLAIM_TYPE_ID = "SET_SELECTED_CLAIM_TYPE_ID";

export const SET_REJECTED_RECEIPT = "SET_REJECTED_RECEIPT";
export const SET_REJECTED_SUPPORTING_DOCUMENTS = "SET_REJECTED_SUPPORTING_DOCUMENTS";
export const SKIP_OCR = "SKIP_OCR";

export const INCREMENT_OCR_REQUEST_COUNT = "INCREMENT_OCR_REQUEST_COUNT";

export const GET_CLAIM_NEED_HELP_SUCCESS = "GET_CLAIM_NEED_HELP_SUCCESS";
export const GET_CLAIM_NEED_HELP_ERROR = "GET_CLAIM_NEED_HELP_ERROR";

export const GET_CLAIM_NEED_HELP_START = "GET_CLAIM_NEED_HELP_START";
export const POST_CLAIMS_NEED_HELP_SUCCESS = "POST_CLAIMS_NEED_HELP_SUCCESS";
export const POST_CLAIMS_NEED_HELP_ERROR = "POST_CLAIMS_NEED_HELP_ERROR";

export const GET_CLAIM_DOCUMENTS_START = "GET_CLAIM_DOCUMENTS_START";
export const GET_CLAIM_DOCUMENTS_SUCCESS = "GET_CLAIM_DOCUMENTS_SUCCESS";
export const GET_CLAIM_DOCUMENTS_ERROR = "GET_CLAIM_DOCUMENTS_ERROR";

export const SET_SUPPORTING_DOCUMENTS_SUCCESS = "SET_SUPPORTING_DOCUMENTS_SUCCESS";
export const SET_SUPPORTING_DOCUMENTS_ERROR = "SET_SUPPORTING_DOCUMENTS_ERROR";
export const REMOVE_SUPPORTING_DOCUMENT = "REMOVE_SUPPORTING_DOCUMENT";

export const SAVE_CLAIM_DOCUMENTS_START = "SAVE_CLAIM_DOCUMENTS_START";
export const SAVE_CLAIM_DOCUMENTS_SUCCESS = "SAVE_CLAIM_DOCUMENTS_SUCCESS";
export const SAVE_CLAIM_DOCUMENTS_ERROR = "SAVE_CLAIM_DOCUMENTS_ERROR";

export const GET_CLAIM_DETAIL_START = "GET_CLAIM_DETAIL_START";
export const GET_CLAIM_DETAIL_SUCCESS = "GET_CLAIM_DETAIL_SUCCESS";
export const GET_CLAIM_DETAIL_ERROR = "GET_CLAIM_DETAIL_ERROR";
export const CLEAR_GET_CLAIM_DETAIL = "CLEAR_GET_CLAIM_DETAIL";

export const SUBMIT_CLAIM_BEGIN = "SUBMIT_CLAIM_BEGIN";
export const SUBMIT_CLAIM_SUCCESS = "SUBMIT_CLAIM_SUCCESS";
export const SUBMIT_CLAIM_ERROR = "SUBMIT_CLAIM_ERROR";

export const GET_CLAIMS_DASHBOARD_START = "GET_CLAIMS_DASHBOARD_START";
export const GET_CLAIMS_DASHBOARD_SUCCESS = "GET_CLAIMS_DASHBOARD_SUCCESS";
export const GET_CLAIMS_DASHBOARD_ERROR = "GET_CLAIMS_DASHBOARD_ERROR";

export const SET_SELECTED_QUESTION_TAG = "SET_SELECTED_QUESTION_TAG";
export const SET_SELECTED_CATEGORY = "SET_SELECTED_CATEGORY";
export const SET_SELECTED_CLAIM = "SET_SELECTED_CLAIM";

export const GET_DELEGATED_EMPLOYEES_START = "GET_DELEGATED_EMPLOYEES_START";
export const GET_DELEGATED_EMPLOYEES_SUCCESS = "GET_DELEGATED_EMPLOYEES_SUCCESS";
export const GET_DELEGATED_EMPLOYEES_ERROR = "GET_DELEGATED_EMPLOYEES_ERROR";
export const SET_DELEGATED_EMPLOYEES = "SET_DELEGATED_EMPLOYEES";
export const SET_DELEGATED_BY_EMPLOYEE_KEY = "SET_DELEGATED_BY_EMPLOYEE_KEY";
export const POST_DECISION_START = "POST_DECISION_START";
export const POST_DECISION_SUCCESS = "POST_DECISION_SUCCESS";
export const POST_DECISION_ERROR = "POST_DECISION_ERROR";

export const CLEAR_ERROR = "CLEAR_ERROR";

export const GET_CLINICS_START = "GET_CLINICS_START";
export const GET_CLINICS_SUCCESS = "GET_CLINICS_SUCCESS";
export const GET_CLINICS_ERROR = "GET_CLINICS_ERROR";
export const GET_SEARCH_CLINICS_START = "GET_SEARCH_CLINICS_START";
export const GET_SEARCH_CLINICS_SUCCESS = "GET_SEARCH_CLINICS_SUCCESS";
export const GET_SEARCH_CLINICS_ERROR = "GET_SEARCH_CLINICS_ERROR";

export const GET_CAPTURED_PHOTO = "GET_CAPTURED_PHOTO";
export const CLEAR_CAPTURED_PHOTO = "CLEAR_CAPTURED_PHOTO";

export const START_CAMERA_SUCESS = "START_CAMERA_SUCESS";
export const START_CAMERA_ERROR = "START_CAMERA_ERROR";

export const GET_CURRENCY_EXCHANGE_RATES_START = "GET_CURRENCY_EXCHANGE_RATES_START";
export const GET_CURRENCY_EXCHANGE_RATES_SUCCESS = "GET_CURRENCY_EXCHANGE_RATES_SUCCESS";
export const GET_CURRENCY_EXCHANGE_RATES_ERROR = "GET_CURRENCY_EXCHANGE_RATES_ERROR";

export const SET_SELECTED_E_CARDS = "SET_SELECTED_E_CARDS";
export const GET_E_CARDS_START = "GET_E_CARDS_START";
export const GET_E_CARDS_SUCCESS = "GET_E_CARDS_SUCCESS";
export const GET_E_CARDS_ERROR = "GET_E_CARDS_ERROR";

const normalizeClaimFields = fields => {
  return fields.map(({ fieldId, allowOther, dataType, items, name, ...rest }) => {
    const formattedItems =
      dataType === "List" &&
      Array.isArray(items) &&
      items.map(item => ({
        id: item.id,
        value: item.id,
        label: item.value,
        isDefault: item.isDefault,
      }));
    const formattedProps = formattedItems && {
      items: formattedItems,
    };

    return {
      id: fieldId,
      label: name,
      dataType: dataType === "List" && allowOther ? "Autocomplete" : dataType,
      name: humps.camelize(fieldId),
      ...formattedProps,
      ...rest,
    };
  });
};

const normalizeOCRFields = fields => {
  return fields.map(({ id, ...rest }) => {
    return {
      id: id,
      name: humps.camelize(id),
      ...rest,
    };
  });
};

export const getClaimCategories = (
  planId,
  selectedDelegator,
  isServiceProvider = false
) => dispatch => {
  dispatch({ type: GET_CLAIM_CATEGORIES_START });

  api
    .getClaimCategories(planId, selectedDelegator, isServiceProvider)
    .then(response => {
      dispatch({
        type: GET_CLAIM_CATEGORIES_SUCCESS,
        payload: { ...response.body },
      });
    })
    .catch(err => {
      dispatch({
        type: GET_CLAIM_CATEGORIES_ERROR,
        payload: err.response ? err.response.body : err,
      });
    });
};

export const setSelectedClaimant = claimant => dispatch => {
  dispatch({
    type: SET_SELECTED_CLAIMANT,
    payload: claimant,
  });
};

export const setSelectedPlanYear = planId => dispatch => {
  dispatch({
    type: SET_SELECTED_PLAN_YEAR,
    payload: planId,
  });
};

export const setSelectedClaimTypeId = claimTypeId => dispatch => {
  dispatch({
    type: SET_SELECTED_CLAIM_TYPE_ID,
    payload: claimTypeId,
  });
};

export const getClaimAccounts = (planId, claimItemId, selectedDelegator) => dispatch => {
  dispatch({ type: GET_CLAIM_ACCOUNTS_START });

  api
    .getClaimAccounts(planId, claimItemId, selectedDelegator)
    .then(response => {
      dispatch({
        type: GET_CLAIM_ACCOUNTS_SUCCESS,
        payload: [...response.body],
      });
    })
    .catch(err => {
      dispatch({
        type: GET_CLAIM_ACCOUNTS_ERROR,
        payload: err.response ? err.response.body : err,
      });
    });
};

export const getClaimItem = (
  planId,
  claimItemId,
  claimantId,
  claimantType,
  selectedDelegator
) => dispatch => {
  dispatch({ type: GET_CLAIM_ITEM_START });

  const params = { planId, claimItemId, claimantId, claimantType, selectedDelegator };
  return api
    .getClaimItem(params)
    .then(response => {
      const formFields = normalizeClaimFields(response.body.formFields);
      const readOnlyFields = normalizeClaimFields(response.body.readOnlyFields);
      dispatch({
        type: GET_CLAIM_ITEM_SUCCESS,
        payload: { ...response.body, formFields: formFields, readOnlyFields: readOnlyFields },
      });
    })
    .catch(err => {
      dispatch({
        type: GET_CLAIM_ITEM_ERROR,
        payload: err.response ? err.response.body : err,
      });
    });
};

export const checkClaimReachLimit = params => dispatch => {
  dispatch({ type: CHECK_CLAIM_REACH_LIMIT_START });

  return api
    .checkClaimReachLimit(params)
    .then(response => {
      dispatch({
        type: CHECK_CLAIM_REACH_LIMIT_SUCCESS,
        payload: { ...response.body },
      });
      return response.body.reachLimit;
    })
    .catch(err => {
      dispatch({
        type: CHECK_CLAIM_REACH_LIMIT_ERROR,
        payload: err.response ? err.response.body : err,
      });
    });
};

export const convertHeic = file => dispatch => {
  dispatch({ type: CONVERT_HEIC_START });

  return api
    .convertHeic(file)
    .then(response => {
      // Extract blob from XMLHttpRequest response
      const blob = new Blob([response.xhr.response], { type: response.type });

      dispatch({
        type: CONVERT_HEIC_SUCCESS,
        payload: blob,
      });
      return blob;
    })
    .catch(err => {
      dispatch({
        type: CONVERT_HEIC_ERROR,
        payload: err.message || "Unknown error occurred",
      });
      throw err;
    });
};

export const uploadReceipt = (file, selectedDelegator) => dispatch => {
  dispatch({ type: UPLOAD_CLAIM_RECEIPT_START });

  api
    .uploadClaimReceipt(file, selectedDelegator)
    .then(response => {
      dispatch({
        type: UPLOAD_CLAIM_RECEIPT_SUCCESS,
        payload: response.body,
      });
    })
    .catch(err => {
      dispatch({
        type: UPLOAD_CLAIM_RECEIPT_ERROR,
        payload: err.response ? err.response.body : err,
      });
    });
};

export const setSupportingDocuments = files => dispatch => {
  dispatch({
    type: SET_SUPPORTING_DOCUMENTS_SUCCESS,
    payload: files,
  });
};

export const removeSupportingDocument = file => ({
  type: REMOVE_SUPPORTING_DOCUMENT,
  payload: file,
});

export const removeReceipt = (objectId, selectedDelegator) => dispatch => {
  dispatch({ type: DELETE_CLAIM_RECEIPT_START });

  api
    .removeClaimReceipt(objectId, selectedDelegator)
    .then(res => {
      dispatch({
        type: DELETE_CLAIM_RECEIPT_SUCCESS,
      });
    })
    .catch(err => {
      dispatch({
        type: DELETE_CLAIM_RECEIPT_ERROR,
        payload: err.response ? err.response.body : err,
      });
    });
};

export const removeReferral = (objectId, selectedDelegator) => dispatch => {
  dispatch({ type: DELETE_CLAIM_REFERRAL_START });

  api
    .removeClaimReferral(objectId, selectedDelegator)
    .then(res => {
      dispatch({
        type: DELETE_CLAIM_REFERRAL_SUCCESS,
      });
    })
    .catch(err => {
      dispatch({
        type: DELETE_CLAIM_REFERRAL_ERROR,
        payload: err.response ? err.response.body : err,
      });
    });
};

export const removeDocument = (objectId, selectedDelegator) => dispatch => {
  dispatch({ type: DELETE_CLAIM_DOCUMENT_START });

  api
    .removeClaimDocument(objectId, selectedDelegator)
    .then(res => {
      dispatch({
        type: DELETE_CLAIM_DOCUMENT_SUCCESS,
      });
    })
    .catch(err => {
      dispatch({
        type: DELETE_CLAIM_DOCUMENT_ERROR,
        payload: err.response ? err.response.body : err,
      });
    });
};

export const getReceiptOCR = (objectId, selectedDelegator) => dispatch => {
  dispatch({ type: GET_RECEIPT_OCR_START });

  api
    .getReceiptOCR(objectId, selectedDelegator)
    .then(response => {
      if (response.body && response.body.status === "success") {
        const fields = normalizeOCRFields(response.body.fields);
        dispatch({
          type: GET_RECEIPT_OCR_SUCCESS,
          payload: { ...response.body, fields: fields },
        });
      } else if (response.body && response.body.status === "error") {
        dispatch({
          type: GET_RECEIPT_OCR_ERROR,
          payload: response.body,
        });
      }
    })
    .catch(err => {
      dispatch({
        type: GET_RECEIPT_OCR_ERROR,
        payload: err.response ? err.response.body : err,
      });
    });
};

export const setRejectedReceipt = files => dispatch => {
  dispatch({ type: SET_REJECTED_RECEIPT, payload: files });
};

export const setRejectedSupportingDocumentFiles = files => dispatch => {
  dispatch({ type: SET_REJECTED_SUPPORTING_DOCUMENTS, payload: files });
};

export const skipOCRProcess = () => dispatch => {
  dispatch({
    type: SKIP_OCR,
  });
};

export const incrementOCRRequestCount = () => dispatch => {
  dispatch({
    type: INCREMENT_OCR_REQUEST_COUNT,
  });
};

export const saveClaimDraft = (data, dispatch, props) => {
  dispatch({ type: SAVE_CLAIM_DRAFT_BEGIN });
  const { receipt, userAccepted, limitAccepted, ...restData } = data;
  const {
    push,
    match: { params },
    query,
  } = props;
  const payload = {
    ...restData,
    receiptFilesIds: Array.isArray(receipt) && receipt.length > 0 ? [receipt[0].objectId] : [],
  };
  return api
    .saveClaimDraft(payload, params.selectedDelegator, limitAccepted, userAccepted)
    .then(res => {
      if (res && res.body) {
        const { claimObjectId } = res.body;
        dispatch({ type: SAVE_CLAIM_DRAFT_SUCCESS, payload: res.body });
        let queryStr = "";
        if (query.claimantId && query.claimantType) {
          queryStr = `?claimantId=${query.claimantId}&claimantType=${query.claimantType}`;
        }
        push(
          params.selectedDelegator
            ? `/claims/documents/${claimObjectId}/${params.selectedDelegator}${queryStr}`
            : `/claims/documents/${claimObjectId}${queryStr}`
        );
      }
    })
    .catch(err => {
      dispatch({
        type: SAVE_CLAIM_DRAFT_ERROR,
        payload: err.response || err,
      });
    });
};

export const postClaimsNeedHelp = (data, dispatch, props, questionID) => {
  const payload = {
    ...data,
    selectedTagId: questionID,
  };

  return api
    .postClaimsNeedHelp(payload)
    .then(response => {
      dispatch({
        type: POST_CLAIMS_NEED_HELP_SUCCESS,
        payload: response.body,
      });
    })
    .catch(err => {
      dispatch({
        type: POST_CLAIMS_NEED_HELP_ERROR,
        payload: err.response ? err.response.body : err,
      });
    });
};

export const getClaimsNeedHelp = () => dispatch => {
  api
    .getClaimsNeedHelp()
    .then(response => {
      dispatch({
        type: GET_CLAIM_NEED_HELP_SUCCESS,
        payload: { ...response.body },
      });
    })
    .catch(err => {
      dispatch({
        type: GET_CLAIM_NEED_HELP_ERROR,
        payload: err.response ? err.response.body : err,
      });
    });
};

export const getClaimDocuments = (claimId, selectedDelegator) => dispatch => {
  dispatch({ type: GET_CLAIM_DOCUMENTS_START });

  return api
    .getClaimDocuments(claimId, selectedDelegator)
    .then(res => {
      dispatch({ type: GET_CLAIM_DOCUMENTS_SUCCESS, payload: res.body });
    })
    .catch(err => {
      dispatch({
        type: GET_CLAIM_DOCUMENTS_ERROR,
        payload: err.response ? err.response.body : err,
      });
    });
};

export const saveClaimDocuments = (data, dispatch, props) => {
  dispatch({ type: SAVE_CLAIM_DOCUMENTS_START });
  const { claimId, referral, supportingDocuments, ...restData } = data;
  const {
    match: { params },
    query,
  } = props;

  const documentIds =
    Array.isArray(supportingDocuments) &&
    supportingDocuments.reduce((obj, item) => {
      return item.objectId ? [...obj, item.objectId] : [...obj];
    }, []);

  const referralPromise =
    referral && !referral.objectId && api.uploadClaimReferral(referral, params.selectedDelegator);
  const newDocs = supportingDocuments.filter(x => !x.objectId);

  const supportingDocumentsPromises =
    Array.isArray(newDocs) &&
    Promise.all(
      newDocs.map(item => {
        return api.uploadClaimDocument(item, params.selectedDelegator);
      })
    );

  return Promise.all([supportingDocumentsPromises, referralPromise]).then(responses => {
    const [docResponses, referralResponse] = responses;
    const finalReferralId =
      referral && referral.objectId
        ? referral.objectId
        : referralResponse && referralResponse.body
        ? referralResponse.body.objectId
        : null;

    const finalDocumentsIds = []
      .concat(
        documentIds,
        Array.isArray(supportingDocuments) && supportingDocuments.length > 0
          ? docResponses.map(response => response.body.objectId)
          : null
      )
      .filter(item => item);

    const payload = {
      referralFileId: finalReferralId,
      supportingDocumentIds: finalDocumentsIds,
      ...restData,
    };

    return api
      .saveClaimDocuments(claimId, payload, params.selectedDelegator)
      .then(res => {
        const { push } = props;
        dispatch({ type: SAVE_CLAIM_DOCUMENTS_SUCCESS });
        let queryStr = "";
        if (query.claimantId && query.claimantType) {
          queryStr = `?claimantId=${query.claimantId}&claimantType=${query.claimantType}`;
        }
        push(
          params.selectedDelegator
            ? `/claims/preview/${claimId}/${params.selectedDelegator}${queryStr}`
            : `/claims/preview/${claimId}${queryStr}`
        );
      })
      .catch(err => {
        dispatch({
          type: SAVE_CLAIM_DOCUMENTS_ERROR,
          payload: err.response ? err.response.body : err,
        });
      });
  });
};

export const clearClaimDetails = () => dispatch => {
  dispatch({ type: CLEAR_GET_CLAIM_DETAIL });
};

export const getClaimDetail = (claimId, selectedDelegator) => dispatch => {
  dispatch({ type: GET_CLAIM_DETAIL_START });

  return api
    .getClaimDetail(claimId, selectedDelegator)
    .then(res => {
      const attachments = res.body.attachments || [];
      const receipts = attachments.filter(x => x.field == "Receipt") || [];
      if (receipts.length > 0) {
        dispatch({ type: GET_CLAIM_DETAIL_SUCCESS, payload: res.body });
        getReceiptOCR(receipts[0].objectId, selectedDelegator)(dispatch);
      } else {
        dispatch({ type: GET_CLAIM_DETAIL_SUCCESS, payload: res.body });
      }

      dispatch({ type: GET_CLAIM_ITEM_START });
      const params = {
        planId: res.body.benefitPeriod,
        claimItemId: res.body.claimTypeId,
        claimFormId: claimId,
        selectedDelegator: selectedDelegator,
      };
      api.getClaimItem(params).then(response => {
        const formFields = normalizeClaimFields(response.body.formFields);
        const readOnlyFields = normalizeClaimFields(response.body.readOnlyFields);
        dispatch({
          type: GET_CLAIM_ITEM_SUCCESS,
          payload: { ...response.body, formFields: formFields, readOnlyFields: readOnlyFields },
        });

        receipts.length > 0 && getReceiptOCR(receipts[0].objectId, selectedDelegator)(dispatch);
      });
      getClaimAccounts(res.body.benefitPeriod, res.body.claimTypeId, selectedDelegator)(dispatch);
    })
    .catch(err => {
      dispatch({
        type: GET_CLAIM_DETAIL_ERROR,
        payload: err.response ? err.response.body : err,
      });
    });
};

export const submitClaim = (data, dispatch, props) => {
  dispatch({ type: SUBMIT_CLAIM_BEGIN });
  const {
    match: { params },
    push,
  } = props;
  return api
    .submitClaim(data.claimObjectId, data.consent, params.selectedDelegator)
    .then(res => {
      if (res && res.body) {
        dispatch({ type: SUBMIT_CLAIM_SUCCESS, payload: res.body });
        push(
          params.selectedDelegator
            ? `/claims/${data.claimObjectId}/success/${params.selectedDelegator}`
            : `/claims/${data.claimObjectId}/success`
        );
      }
    })
    .catch(err => {
      dispatch({
        type: SUBMIT_CLAIM_ERROR,
        payload: err.response ? err.response.body : err,
      });
    });
};

export const getClaimDashboard = (planId, selectedDelegator) => dispatch => {
  dispatch({ type: GET_CLAIMS_DASHBOARD_START });

  api
    .getClaimDashboard(planId, selectedDelegator)
    .then(response => {
      dispatch({
        type: GET_CLAIMS_DASHBOARD_SUCCESS,
        payload: { ...response.body },
      });
    })
    .catch(err => {
      dispatch({
        type: GET_CLAIMS_DASHBOARD_ERROR,
        payload: err.response ? err.response.body : err,
      });
    });
};

export const setSelectedQuestionTag = tag => {
  return {
    type: SET_SELECTED_QUESTION_TAG,
    payload: tag,
  };
};

export const setSelectedCategory = category => {
  return {
    type: SET_SELECTED_CATEGORY,
    payload: category,
  };
};

export const setSelectedClaim = claim => {
  return {
    type: SET_SELECTED_CLAIM,
    payload: claim,
  };
};

export const setDelegatedEmployees = data => dispatch => {
  dispatch({ type: SET_DELEGATED_EMPLOYEES, payload: data });
};

export const setDelegatedByEmployeeKey = data => dispatch => {
  dispatch({ type: SET_DELEGATED_BY_EMPLOYEE_KEY, payload: data });
};

export const getDelegatedEmployees = () => dispatch => {
  dispatch({ type: GET_DELEGATED_EMPLOYEES_START });

  return api
    .getEmployeesByDelegation()
    .then(({ body }) => {
      const meta = {
        employeeKey: "me",
        delegatedEmployeeName: "Myself",
      };

      dispatch({
        type: GET_DELEGATED_EMPLOYEES_SUCCESS,
        payload: body.length > 0 ? [].concat(meta).concat(body) : body,
      });
    })
    .catch(err => {
      dispatch({
        type: GET_DELEGATED_EMPLOYEES_ERROR,
        payload: err.response ? err.response.body : err,
      });
    });
};

export const getInsurerClaimCategories = planId => dispatch => {
  dispatch({ type: GET_INSURER_CLAIM_CATEGORIES_START });

  api
    .getClaimCategories(planId, null, true)
    .then(response => {
      dispatch({
        type: GET_INSURER_CLAIM_CATEGORIES_SUCCESS,
        payload: { ...response.body },
      });
    })
    .catch(err => {
      dispatch({
        type: GET_INSURER_CLAIM_CATEGORIES_ERROR,
        payload: err.response ? err.response.body : err,
      });
    });
};

export const clearError = () => dispatch => {
  dispatch({ type: CLEAR_ERROR });
};

export const saveCapturedPhoto = () => dispatch => {
  dispatch({ type: GET_CAPTURED_PHOTO });
};

export const startCameraPhoto = () => dispatch => {
  dispatch({ type: START_CAMERA_SUCESS });
};

export const clearCameraState = () => dispatch => {
  dispatch({ type: START_CAMERA_ERROR });
};

export const getClinics = type => dispatch => {
  dispatch({ type: GET_CLINICS_START });

  api
    .getAllClinics(type)
    .then(response => {
      dispatch({
        type: GET_CLINICS_SUCCESS,
        payload: response.body,
      });
    })
    .catch(err => {
      dispatch({
        type: GET_CLINICS_ERROR,
        payload: err.response ? err.response.body : err,
      });
    });
};

export const searchClinics = data => dispatch => {
  dispatch({ type: GET_SEARCH_CLINICS_START });

  const filteredData = { ...data };
  if (!data.address) delete filteredData.address;
  if (!data.providerType) delete filteredData.providerType;
  if (!data.providerName) delete filteredData.providerName;

  api
    .getSearchClinics(filteredData)
    .then(response => {
      dispatch({
        type: GET_SEARCH_CLINICS_SUCCESS,
        payload: response.body,
      });
    })
    .catch(err => {
      dispatch({
        type: GET_SEARCH_CLINICS_ERROR,
        payload: err.response ? err.response.body : err,
      });
    });
};

export const postExpenseClaim = (
  decision,
  objectId,
  delegatorKey,
  requestData,
  history
) => dispatch => {
  dispatch({ type: POST_DECISION_START });
  api
    .postExpenseClaims({ decision, objectId, delegatorKey, data: requestData })
    .then(response => {
      dispatch({
        type: POST_DECISION_SUCCESS,
        payload: response.body,
      });
      history.push(`/claims/track`);
    })
    .catch(err => {
      dispatch({
        type: POST_DECISION_ERROR,
        payload: err.response ? err.response.body : err,
      });
    });
};
export const getCurrencyExchangeRates = (
  planId,
  receiptDate,
  currencyFrom,
  selectedDelegator
) => dispatch => {
  dispatch({ type: GET_CURRENCY_EXCHANGE_RATES_START });

  const params = { planId, receiptDate, currencyFrom, selectedDelegator };
  api
    .getCurrencyExchangeRates(params)
    .then(response => {
      dispatch({
        type: GET_CURRENCY_EXCHANGE_RATES_SUCCESS,
        payload: response.body,
      });
    })
    .catch(err => {
      dispatch({
        type: GET_CURRENCY_EXCHANGE_RATES_ERROR,
        payload: {
          ...err,
          body:
            "Exchange rate can’t be fetched from XE for the Receipt date selected. Please try again later.",
        },
      });
    });
};

export const setSelectedEcards = data => dispatch => {
  dispatch({ type: SET_SELECTED_E_CARDS, payload: data });
};

export const getECardsData = () => dispatch => {
  dispatch({ type: GET_E_CARDS_START });

  api
    .getECardsList()
    .then(response => {
      dispatch({
        type: GET_E_CARDS_SUCCESS,
        payload: response.body,
      });
    })
    .catch(err => {
      dispatch({
        type: GET_E_CARDS_ERROR,
        payload: err.response ? err.response.body : err,
      });
    });
};



// WEBPACK FOOTER //
// ./actions/claimActionsPP.js